import { useTranslation } from 'react-i18next'
import { Box, Button, CircularProgress, Container, TextField } from '@mui/material';
import { ArrowForward, LocationOnOutlined, MailOutline, PhoneOutlined } from '@mui/icons-material';
import SocialLink from './SocialLink';
import Waves from './ui/Waves';
import React, { useState } from 'react';
interface Props { }

function Contact(props: Props) {
    const { t } = useTranslation();
    // const { register, reset, handleSubmit, formState: { errors }, setValue } = useForm();
    const [load] = useState(false);


    const [sent, setSent] = useState(false);

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const field = (key: string) => String(form.get(key) ?? '').trim();
        const body = [
            field('message'),
            '',
            '—',
            field('name'),
            field('email'),
            field('phone'),
        ].filter((line, index) => index < 3 || line).join('\n');
        window.location.href = `mailto:contact@ibgalphatech.com?subject=${encodeURIComponent(field('subject') + ' / SITE INTERNET')}&body=${encodeURIComponent(body)}`;
        setSent(true);
    }

    return (
        <div  >
            {/* <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre45'} lien={'Label.Titre.titre13'} /> */}
            {/* <br /><br /><br /><br /><br /><br /><br /><br />
            <br />
            <br /> */}

            

            {/* <br /><br />


            <Container maxWidth='lg'>
                <Box className='boxCS warning' padding={2} borderRadius={3}>
                    <>
                        <Warning fontSize='large' color='warning' />
                    </>
                    <>
                        <Typography>{t("SOUS_TITRE.CandidatureSpontanee")}</Typography>
                        <br />
                        <motion.button
                            onClick={postules}
                            whileHover={{
                                scale: 1.2,
                                transition: { duration: 1 },
                            }}
                            whileTap={{ scale: 0.9 }}
                            className='btn'>{t("Bouton.Condidaturespontanee")}
                        </motion.button>
                    </>
                </Box>
            </Container>
            <br /><br /> */}

            <Box display={"flex"}>
                {/* <Box display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseGauche} alt="" />
                </Box> */}

                <Container maxWidth='lg' disableGutters>
                    <Box className='ibg-contact'>
                        {/* <Box className='resume' borderRadius={3}>

                            <Box>
                                <Typography padding={"5%"} fontWeight={"bold"} variant='h5'>{t("Label.Titre.titre47")}</Typography>
                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><LocationOn /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("Label.Titre.titre27")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.siege")}, {t("ENTETE.ville")}</label>
                                    </Box>
                                </Box>

                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><PhoneAndroid /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("ENTETE.telephone")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.numero")}</label>
                                    </Box>
                                </Box>

                                <Box padding={"5%"} gap={1} display={'flex'}>
                                    <Box className='header-icon'><IconButton size='small' ><Mail /></IconButton></Box>
                                    <Box >
                                        <label className='primaryText'>{t("ENTETE.email")}</label><br />
                                        <label className='seconderyText'>{t("ENTETE.email_value")}</label>
                                    </Box>
                                </Box>
                                <hr />

                                <Typography padding={"5%"} fontWeight={"bold"} variant='h5'>{t("Label.Titre.titre48")}</Typography>
                                <Box padding={"5%"} gap={1} display={"flex"}>
                                    <IconButton style={{ border: "1px solid" }} ><LinkedIn /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} color='error'><Instagram /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} ><Facebook /></IconButton>
                                    <IconButton style={{ border: "1px solid" }} color='error'><Mail /></IconButton>
                                </Box>
                            </Box>

                        </Box>
                        <hr style={{ visibility: 'hidden' }} /> */}
                        <Box className='ibg-contact__info'>
                            <Waves />
                            <div>
                                <span className='ibg-eyebrow ibg-eyebrow--light'>IBG Alpha Technology</span>
                                <h3>{t("Pages.contactPanelTitle")}</h3>
                                <p>{t("Pages.contactPanelText")}</p>
                            </div>
                            <ul>
                                <li><span><PhoneOutlined /></span><div><small>{t("Pages.phone")}</small><a href="tel:+237690767963">(+237) 690 767 963</a></div></li>
                                <li><span><MailOutline /></span><div><small>{t("Pages.email")}</small><a href="mailto:contact@ibgalphatech.com">contact@ibgalphatech.com</a></div></li>
                                <li><span><LocationOnOutlined /></span><div><small>{t("Pages.address")}</small><strong>{t("Pages.addressValue")}</strong></div></li>
                            </ul>
                            <div>
                                <small className='ibg-contact__label'>{t("Pages.followUs")}</small>
                                <SocialLink />
                            </div>
                        </Box>
                        <Box className='CantactForm ibg-contact__form'>

                            {/* <Spin spinning={load}>

                                
                            </Spin> */}
                            {/* onSubmit={handleSubmit(SendMail)} */}
                            {/* <Typography fontWeight={"bold"} variant='h5'>{(t("Label.Titre.titre1")).toUpperCase()}</Typography> */}
                            {/* <label className='textgray'>{t("Label.Titre.titre2")}</label><br /><br /> */}
                            <form className='ibg-form' onSubmit={handleSubmit}>
                                <div className='ibg-form__grid'>
                                    <TextField
                                        // {...register("tel", { required: true })}
                                        name="name"
                                        label={t("Label.Titre.titre3")}
                                        type={"text"} variant="outlined"
                                        autoComplete="name"
                                        required
                                        fullWidth
                                    />
                                    <TextField
                                        // {...register("email", { required: true })}
                                        name="phone"
                                        label={t("Label.Titre.titre4")}
                                        type={"tel"} variant="outlined"
                                        autoComplete="tel"
                                        fullWidth
                                    />
                                    <TextField
                                        // {...register("ville", { required: true })}
                                        name="email"
                                        label={t("Label.Titre.titre5")}
                                        type={"email"} variant="outlined"
                                        autoComplete="email"
                                        required
                                        fullWidth
                                    />
                                    <TextField
                                        // {...register("sujet", { required: true })}
                                        name="subject"
                                        label={t("Label.Titre.titre6")}
                                        type={"text"} variant="outlined"
                                        required
                                        fullWidth
                                    />
                                    <TextField
                                        // {...register("message", { required: true })}
                                        name="message"
                                        label={t("Label.Titre.titre7")}
                                        type={"text"} variant="outlined"
                                        multiline
                                        minRows={8}
                                        required
                                        fullWidth
                                        className='ibg-form__full'
                                    />
                                    {/* <Box>
                                        <UploadFile text={'Cliquez ou clissez un fichier ici'} />
                                    </Box> */}
                                </div>
                                <div className='ibg-form__footer'>
                                    <small>{sent ? t("Pages.mailtoNote") : "* " + t("Pages.required")}</small>
                                    <Button
                                        size='large'
                                        variant='contained'
                                        sx={{ borderRadius: 999, px: 4, py: 1.4, fontSize: 15 }}
                                        disabled={load}

                                        endIcon={
                                            load ? <CircularProgress size={"20px"} color='inherit' /> : <ArrowForward fontSize='small' />
                                        }
                                        className='btn-submit'
                                        type='submit'
                                    >{t("Label.Titre.titre8")}</Button>
                                </div>
                            </form>
                        </Box>
                    </Box>
                </Container>
                {/* <Box display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseDroite} alt="" />
                </Box> */}
            </Box >
        </div >
    )
}
export default Contact